import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const PHOTOS = [
  { src: "/images/marypawpins/spaniel-inverness-castle.jpg", alt: "A spaniel on a walk past Inverness Castle" },
  { src: "/images/marypawpins/dachshund-forest-logs.jpg", alt: "A dapple dachshund on the forest logs" },
  { src: "/images/marypawpins/dog-water-leap.jpg", alt: "A dog leaping through the water" },
  { src: "/images/marypawpins/fox-red-lab-handshake.jpg", alt: "A fox-red labrador offering a paw" },
  { type: "video", src: "/videos/rottweiler-charge.mp4", poster: "/videos/rottweiler-charge.jpg", alt: "A rottweiler charging through the long grass" },
  { src: "/images/marypawpins/corgi-smile-field.webp", alt: "A corgi smiling in the field" },
  { src: "/images/marypawpins/border-collie-hills.jpg", alt: "A border collie on the hill path" },
];

export const GalleryStrip = () => (
  <section className="py-16 sm:py-24 bg-[#EFECE3] overflow-hidden" data-testid="gallery-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <div>
          <p className="eyebrow">Around &amp; about</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium text-[#292A26] tracking-tight mt-4" data-testid="gallery-heading">
            A little look at life around here.
          </h2>
        </div>
        <Link
          to="/meet-the-gang"
          data-testid="meet-the-gang-link"
          className="inline-flex items-center gap-2 text-sm font-semibold text-[#3F4A38] group"
        >
          Meet the Gang
          <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </Link>
      </div>
    </div>
    <div className="mt-12 flex gap-4 sm:gap-6 overflow-x-auto no-scrollbar px-6 sm:px-8 lg:px-12 pb-2" data-testid="gallery-strip">
      {PHOTOS.map((p, i) =>
        p.type === "video" ? (
          <video
            key={p.src}
            src={p.src}
            poster={p.poster}
            autoPlay muted loop playsInline
            aria-label={p.alt}
            className={`rounded-3xl object-cover flex-shrink-0 ${i % 2 === 0 ? "w-64 sm:w-80 aspect-[4/5]" : "w-64 sm:w-80 aspect-[4/5] sm:mt-10"}`}
          />
        ) : (
          <img
            key={p.src}
            src={p.src}
            alt={p.alt}
            className={`rounded-3xl object-cover flex-shrink-0 ${i % 2 === 0 ? "w-64 sm:w-80 aspect-[4/5]" : "w-64 sm:w-80 aspect-[4/5] sm:mt-10"}`}
          />
        )
      )}
    </div>
  </section>
);
